define('module/cookie-consent',[
    'underscore',
    'jquery',
    'cnf',
    'util/cookie'
], function(_, $, Cnf, Cookie) {
    'use strict';

    return function()
    {
        this.options={
            selector:{
                consent:'.cookie-consent',
                hide:'.trigger-close'
            },
            consentName:'cookie-consent',
            hashTriggerOpenBorlabsPrefence: '#borlabs-cookie-preference'
        };

        this.init=function()
        {
            //this.initConsent();
            this.initBorlabs();
        };

        this.initConsent=function()
        {
            this.$consent=$(this.options.selector.consent);
            if(this.$consent.length<=0) {
                return;
            }
            
            if(!Cookie.get(this.options.consentName)) {
                TweenMax.to(this.$consent, .2, {
                    autoAlpha: 1
                });
                this.$consent.find(this.options.selector.hide).on(Cnf.click, _.bind(this.hideConsent,this));
            }
        };

        this.hideConsent=function()
        {
            TweenMax.to(this.$consent, .5, {
                autoAlpha: 0
            });
            
            var oDate = new Date;
            oDate.setFullYear(oDate.getFullYear() +1);
            Cookie.set(this.options.consentName, 'true', oDate.toGMTString());
        };


        /**
         * init borlabs
         * 
         * @jira FDZ-549
         * @date 2022-05-10
         * @author sh@sopg.de
         */
        this.initBorlabs = function()
        {
            //trigger borlabs preference center if given
            if(
                (window.location.hash === this.options.hashTriggerOpenBorlabsPrefence)
                && (typeof BorlabsCookie === 'object')
            ) {
                BorlabsCookie.openCookiePreference();
            }
        }

        this.init();
    };
});
